<template>
  <div class="container">
    <div class="mydiv">
      <div @click="startAnimation()" class="mydiv1">开始</div>
      <div @click="pauseAnimation()" class="mydiv1">暂停</div>
      <div @click="resumeAnimation()" class="mydiv1">继续</div>
      <div @click="stopAnimation()" class="mydiv1">结束</div>
    </div>

    <!-- 地图容器 -->
    <div id="container"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      map: null,
      carPath: null, // 小车移动路线
      mark: null,
      lineArr: [
        [116.478935, 39.997761],
        [116.478939, 39.997825],
        [116.478912, 39.998549],
        [116.478912, 39.998549],
        [116.478998, 39.998555],
        [116.478998, 39.998555],
        [116.479282, 39.99856],
        [116.479658, 39.998528],
        [116.480151, 39.998453],
        [116.480784, 39.998302],
        [116.480784, 39.998302],
        [116.481149, 39.998184],
        [116.481573, 39.997997],
        [116.481863, 39.997846],
        [116.482072, 39.997718],
        [116.482362, 39.997718],
        [116.483633, 39.998935],
        [116.48367, 39.998968],
        [116.484648, 39.999861]
      ],
      firstArr: [116.478935, 39.997761]
    };
  },
  props: {
    newdata: Array
  },
  // mounted(){
  //     this.initMap()
  // },
  mounted() {
    setTimeout(() => {
      // console.log(this.newdata, "my数据");
      if (this.newdata) {
        this.lineArr = this.newdata;
        this.firstArr = this.lineArr[0];
      }
      //   this.lineArr=[[120.215516,30.17409],[120.225516,30.17409],[120.215516,30.17509]],
      //  this.firstArr=[120.215516,30.17409]
      // console.log()
      this.initMap();
      this.initroad();
    }, 1000);
  },
  methods: {
    //初始化地图
    initMap() {
      console.log(987654321);
      this.map = new AMap.Map("container", {
        resizeEnable: true, //窗口大小调整
        center: this.firstArr, //中心 firstArr: [116.478935, 39.997761],
        zoom: 20
      });
      console.log(this.map);
      this.marker = new AMap.Marker({
        map: this.map,
        position: this.firstArr,
        icon: "https://webapi.amap.com/images/car.png",
        offset: new AMap.Pixel(-26, -13), //调整图片偏移
        autoRotation: true, //自动旋转
        angle: -90 //图片旋转角度
      });
    },
    //初始化轨迹
    initroad() {
      //绘制还未经过的路线
      this.polyline = new AMap.Polyline({
        map: this.map,
        path: this.lineArr,
        showDir: true,
        strokeColor: "#28F", //线颜色--蓝色
        // strokeOpacity: 1,     //线透明度
        strokeWeight: 6 //线宽
        // strokeStyle: "solid"  //线样式
      });
      //绘制路过了的轨迹
      var passedPolyline = new AMap.Polyline({
        map: this.map,
        strokeColor: "#AF5", //线颜色-绿色
        // path: this.lineArr,
        // strokeOpacity: 1,     //线透明度
        strokeWeight: 6 //线宽
        // strokeStyle: "solid"  //线样式
      });
      this.marker.on("moving", e => {
        passedPolyline.setPath(e.passedPath);
      });
      this.map.setFitView(); //合适的视口
    },
    startAnimation() {
      console.log(this.lineArr, 200);

      this.marker.moveAlong(this.lineArr, 200);
    },
    pauseAnimation() {
      this.marker.pauseMove();
    },
    resumeAnimation() {
      this.marker.resumeMove();
    },
    stopAnimation() {
      this.marker.stopMove();
    }
  }
};
</script>

<style lang="scss" scoped>
#container {
  width: 100%;
  height: 600px;
}
.mydiv {
  display: flex;
  width: 100%;
  justify-content: space-between;
}
.mydiv1 {
  width: 18%;
  height: 30px;
  text-align: center;
  line-height: 30px;
  background: #409eff;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/map/Getpoint1.vue